<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">服务套餐配置</div>
        <div>
          <el-button
            type="primary"
            @click="onSave"
            >保存</el-button
          >
          <el-button @click="onBack">返回</el-button>
        </div>
      </div>
      <div class="detail-content-body-div flex-1">
        <!-- 服务套餐配置表单 -->
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="140px"
          class="form-block"
        >
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item
                label="购买名称"
                prop="payContent"
              >
                <el-select
                  v-model="form.payContent"
                  placeholder="请选择"
                  :disabled="editFlag"
                >
                  <el-option
                    label="家充无忧服务0米"
                    value="0"
                  />
                  <el-option
                    label="家充无忧服务10米"
                    value="10"
                  />
                  <el-option
                    label="家充无忧服务20米"
                    value="20"
                  />
                  <el-option
                    label="家充无忧服务30米"
                    value="30"
                  />
                  <el-option
                    label="家充无忧服务40米"
                    value="40"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="服务费价格（元）"
                prop="price"
              >
                <el-input
                  v-model="form.serviceFeePrice"
                  placeholder="请输入服务费价格"
                  :disabled="editFlag"
                />
              </el-form-item>
              <el-form-item
                label="安装米数（米）"
                prop="installedMeters"
              >
                <el-input-number
                  v-model="form.installedMeters"
                  :min="0"
                  style="width: 300px"
                  :disabled="editFlag"
                  placeholder="请输入安装米数"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="有效期生效时间"
                prop="startExpirationDate"
              >
                <el-date-picker
                  v-model="form.startExpirationDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="备注"
                prop="remark"
              >
                <el-input
                  v-model="form.remark"
                  type="textarea"
                  :rows="6"
                  size="small"
                  :disabled="editFlag"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务套餐ID">
                <el-input
                  v-model="form.serviceActivityId"
                  placeholder="请输入服务套餐ID"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item label="启用状态">
                <el-switch
                  v-model="form.enableStatus"
                  active-text="启用"
                  inactive-text="禁用"
                />
              </el-form-item>
              <el-form-item
                label="有效期状态"
                prop="expirationStatus"
              >
                <el-input
                  v-model="form.expirationStatus"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item
                label="有效期截止时间"
                prop="endExpirationDate"
              >
                <el-radio-group
                  v-model="form.isPermanent"
                  style="margin-right: 10px"
                >
                  <el-radio :label="0">永久</el-radio>
                  <el-radio :label="1">具体时间</el-radio>
                </el-radio-group>
                <el-date-picker
                  v-if="form.isPermanent == 1"
                  v-model="form.endExpirationDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择截止时间"
                  style="width: 70%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 有效期操作日志表格 -->
        <div
          style="margin-bottom: 40px"
          v-if="editFlag"
        >
          <div style="font-weight: bold; margin-bottom: 10px">
            有效期操作日志
          </div>
          <el-table
            :data="logList"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="activityId"
              label="日志Id"
              width="80"
            />
            <el-table-column
              prop="enableStatusName"
              label="启用状态"
            />
            <el-table-column
              prop="expirationStatus"
              label="有效期状态"
            />
            <el-table-column
              prop="beforeStartExpirationDate"
              label="原有效期生效时间"
            />
            <el-table-column
              prop="beforeEndExpirationDate"
              label="原有效期截止时间"
            />
            <el-table-column
              prop="startExpirationDate"
              label="新有效期生效时间"
            />
            <el-table-column
              prop="endExpirationDate"
              label="新有效期截止时间"
            />
            <el-table-column
              prop="lastModifiedByName"
              label="更新人"
            />
            <el-table-column
              prop="lastModifiedWhen"
              label="更新时间"
            />
          </el-table>
          <!-- 分页 -->
          <div class="list-pagination">
            <ZD-pagination
              :pagination="pagination"
              v-on:pageUpdate="getList"
            />
          </div>
        </div>
        <!-- 订单基本信息表单及其他内容保留 -->
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    // 自定义校验规则 - 服务费价格
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入服务费价格"));
      }

      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        return callback(new Error("请输入正确的金额，最多两位小数"));
      }

      if (value < 0) {
        return callback(new Error("服务费价格不能为负数"));
      }

      callback();
    };

    // 自定义校验规则 - 最小安装米数
    const validateMinMeter = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最小安装米数"));
      }

      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        return callback(new Error("请输入正确的米数，最多两位小数"));
      }

      if (value < 0) {
        return callback(new Error("最小安装米数不能为负数"));
      }

      callback();
    };

    // 自定义校验规则 - 最大安装米数
    const validateMaxMeter = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最大安装米数"));
      }

      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        return callback(new Error("请输入正确的米数，最多两位小数"));
      }

      if (value < 0) {
        return callback(new Error("最大安装米数不能为负数"));
      }

      // 如果最小安装米数有值，需要校验最大值不能小于最小值
      if (
        this.form.minMeter &&
        parseFloat(value) < parseFloat(this.form.minMeter)
      ) {
        return callback(new Error("最大安装米数不能小于最小安装米数"));
      }

      callback();
    };

    return {
      serviceActivityId: "",
      editFlag: false,
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      detailBreadCrumb: pageConfig.detailBreadCrumb,
      form: {
        payContent: "",
        serviceActivityId: "",
        priserviceFeePricece: "",
        enableStatus: true,
        installedMeters: "",
        startExpirationDate: "",
        endExpirationDate: "",
        expirationStatus: "",
        expireType: "forever",
      },
      rules: {
        payContent: [
          { required: true, message: "请选择购买名称", trigger: "change" },
        ],
        serviceFeePrice: [
          { required: true, validator: validatePrice, trigger: "blur" },
        ],
        installedMeters: [
          { required: true, trigger: "blur", message: "请输入安装米数" },
        ],
        startExpirationDate: [
          {
            required: true,
            message: "请选择有效期生效时间",
            trigger: "change",
          },
        ],
        endExpirationDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.checked === "date" && !this.form.endExpirationDate) {
                callback(new Error("请选择有效期截止时间"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      logList: [],
      checked: "forever",
    };
  },
  methods: {
    onSave() {
      let _ = this;

      this.form.enableStatus = this.form.enableStatus == true ? 0 : 1;
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验通过，执行保存操作
          console.log("form data:", this.form);
          if (this.editFlag) {
            _.$H
              .post(_, _.$A.activityOrder.editPackage, this.form)
              .then((res) => {
                _.$message.success("修改成功");
                _.getDetail();
              });
          } else {
            _.$H
              .post(_, _.$A.activityOrder.addPackage, this.form)
              .then((res) => {
                _.$message.success("新增成功");
                _.serviceActivityId = res.data.data.serviceActivityId;
                _.getDetail();
              });
          }
        } else {
          // 校验不通过
          // this.$message.error("请检查表单填写是否正确");
          return false;
        }
      });
    },
    onBack() {
      // 返回逻辑
      this.$router.go(-1);
    },
    getList(pagination, reload = false) {
      let _ = this;
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 0;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.serviceActivityId = _.serviceActivityId;
      _.$H
        .post(_, _.$A.activityOrder.serviceActivityId, _.queryInfo)
        .then((res) => {
          _.logList = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
        });
    },
    getDetail() {
      let _ = this;
      _.$H
        .post(_, _.$A.activityOrder.findOne, {
          serviceActivityId: _.serviceActivityId,
        })
        .then((res) => {
          console.log(res.data.data);
          _.form = res.data.data;
          _.form.enableStatus = res.data.data.enableStatus == 0 ? true : false;
        });
    },
  },
  mounted() {
    // 初始化页面数据
    this.editFlag = this.$route.query.edit == 1 ? true : false;
    this.serviceActivityId = this.$route.query.serviceActivityId || "";
    if (this.editFlag) {
      this.getList(this.pagination, true);
      this.getDetail();
    }
  },
};
</script>
